// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info-tooltip-container {
  margin-left: 5px;
  top: 3px;
  display: inline-block;
  position: relative;
}
.info-tooltip-container .info-tooltip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: help;
  color: #717680;
  cursor: pointer;
  top: 2px;
}
.info-tooltip-container .info-tooltip .icon {
  font-size: 13px;
}
.info-tooltip-container .info-tooltip .icon svg {
  margin-left: 0px;
}
/*# sourceMappingURL=InfoTooltip.css.map */`, "",{"version":3,"sources":["webpack://./InfoTooltip.less","webpack://./wp_components/core/Icon/InfoTooltip/InfoTooltip.less"],"names":[],"mappings":"AAEA;EACI,gBAAA;EACA,QAAA;EACA,qBAAA;EACA,kBAAA;ACDJ;ADHA;EAOQ,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,QAAA;ACDR;ADZA;EAeY,eAAA;ACAZ;ADfA;EAiBgB,gBAAA;ACChB;AACA,0CAA0C","sourcesContent":["@import \"../../../../less/variables.less\";\n\n.info-tooltip-container {\n    margin-left: 5px;\n    top: 3px;\n    display: inline-block;\n    position: relative;\n\n    .info-tooltip {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        cursor: help;\n        color: @fg-quaternary;\n        cursor: pointer;\n        top: 2px;\n        .icon {\n            font-size: 13px;\n            svg {\n                margin-left: 0px;\n            }\n        }\n    }\n}\n",".info-tooltip-container {\n  margin-left: 5px;\n  top: 3px;\n  display: inline-block;\n  position: relative;\n}\n.info-tooltip-container .info-tooltip {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: help;\n  color: #717680;\n  cursor: pointer;\n  top: 2px;\n}\n.info-tooltip-container .info-tooltip .icon {\n  font-size: 13px;\n}\n.info-tooltip-container .info-tooltip .icon svg {\n  margin-left: 0px;\n}\n/*# sourceMappingURL=InfoTooltip.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
